<template>
  <div class="ai_container">
    <Header :onPrev="handlePrev" :isShowHome="true" :title="'회원탈퇴'" />
    <div class="mypage_withdraw_wrapper">
      <h3 class="heading_3">
        완료되지 않은<br>
        견적내역이 존재해요!
      </h3>
      <p class="body_6 f_gray_4">
        견적 산정 중에는 탈퇴가 불가능해요.<br>
        견적 신청이 완료된 이후에 탈퇴해주세요.<br/>
        탈퇴한 경우 기존에 결제하신 견적 내역은 확인하실 수 없어요.
      </p>
      <ul>
        <li>
          <div>
            <p class="body_7">견적번호</p> 
            <b class="heading_6">{{estimateNo}}</b>
          </div>
          <div>
            <p class="body_7">주문일시</p>
            <p class="body_7">{{estimateDate}}</p> 
          </div>
          <Button :size="44" :color="'gray'" :label="'견적 내역 바로가기'" :onClick="handleHistory" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Header from '../../../components/ai/AiHeader.vue'
import Button from '../../../components/ai/AiButton.vue'
import LoginSocial from '../../../components/ai/AiLoginSocial.vue'
export default {
  components: {
    Header,
    Button,
    LoginSocial
  },
  data() {
		return {
      estimateNo:Vue.$sessionStorage.get('estimateNo'),
      estimateDate:Vue.$sessionStorage.get('estimateDate'),
    }
  },
  methods: {
    handlePrev () {
      //alert('뒤로가기')
    },
    handleHistory () {
      //alert('견적 내역 바로가기')
      this.$router.push({ name: 'AiEstimateList' })
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
.mypage_withdraw_wrapper {
  padding: 24px 20px 32px;
  background-color: var(--gray-scale-12);
}

.mypage_withdraw_wrapper > p {
  margin: 8px 0 32px;
  word-break: keep-all !important;
}

.mypage_withdraw_wrapper > ul {
  display: grid;
  gap: 12px;
}

.mypage_withdraw_wrapper > ul > li {
  padding: 24px 20px;
  border: 1px solid rgb(236, 238, 241);
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 4px 0px;
  border-radius: 16px;
}
.mypage_withdraw_wrapper > ul > li > div {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 20px;
}

.mypage_withdraw_wrapper > ul > li > div:first-of-type {
  padding-bottom: 20px;
  border-bottom: 1px solid var(--gray-scale-9);
}
</style>



// WEBPACK FOOTER //
// src/views/ai/mypage/AiMypageWithdraw.vue